// extracted by mini-css-extract-plugin
export default {"container":"BidAskBox_container__rWftH"};